import React from "react";
import PropTypes from "prop-types";

import ArticleCard from "../components/article/ArticleCard";
import ArticleStyle from "../components/article/ArticleStyle";
import CatDivider from "../components/common/CatDivider";
import CenterContent from "../components/common/CenterContent";
import getArticlesAndGuides from "../logic/getArticlesAndGuides";
import Page from "../components/common/Page";
import style from "./articles.module.css";

const ArticlesPage = props => {
  const { data } = props;

  // for now guides and articles are all mixed together
  const articles = getArticlesAndGuides(data);

  return (
    <Page>
      <div className={style.intro}>
        <CenterContent wide>
          <ArticleStyle>
            <h1>Articles</h1>
            <p>
              Articles cover a wide range of modern webdev topics including
              React, CSS Modules, and Webpack.
            </p>
          </ArticleStyle>
        </CenterContent>
      </div>
      <div className={style.listOuter}>
        <CenterContent wide>
          <div className={style.list}>
            {articles.map(article => (
              <ArticleCard key={article.path} article={article} />
            ))}
          </div>
        </CenterContent>
      </div>
      <CatDivider />
    </Page>
  );
};
ArticlesPage.propTypes = {
  data: PropTypes.object.isRequired
};
export default ArticlesPage;

export const pageQuery = graphql`
  query ArticlesQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          frontmatter {
            archive
            title
            subtitle
            date
            path
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/articles.js